import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import setConsumerMailboxOptions from '../services/setConsumerMailboxOptions';
import ConsumerMailboxOptions from 'owa-service/lib/contract/ConsumerMailboxOptions';
import PopImapConfigurationState from '../store/schema/PopImapConfigurationState';
import { isConsumer } from 'owa-session-store';

export default action('savePopImapConfiguration')(async function savePopImapConfiguration(
    popImapConfiguration: PopImapConfigurationState
) {
    store.popEnabled = popImapConfiguration.popEnabled;
    store.popMessageDeleteEnabled = popImapConfiguration.popMessageDeleteEnabled;

    if (isConsumer()) {
        let consumerMailboxOptions: ConsumerMailboxOptions = {
            PopEnabled: store.popEnabled,
            PopMessageDeleteEnabled: store.popMessageDeleteEnabled,
        };

        await setConsumerMailboxOptions(consumerMailboxOptions);
    }
});
